export default "__VITE_ASSET__bb9d9d16__"